/**
 * Subscription status values matching Stripe's subscription statuses.
 * Matches backend enum: Levitate.Models.Enums.SubscriptionStatus
 *
 * Note: Unlike DonationFrequency, the backend enum does NOT have a
 * StringEnumConverter applied, so it serializes as the underlying integer.
 * These values must match the C# ordinal positions.
 */
export enum SubscriptionStatus {
	Active = 0,
	Cancelled = 1,
	PastDue = 2,
	Unpaid = 3,
	Incomplete = 4,
	IncompleteExpired = 5,
	Trialing = 6,
	Paused = 7,
}
